import React, { FC, useState } from 'react';
import { Box, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { FacebookIcon } from 'svgs/news';
import { LinkedinIcon } from 'svgs/footer';
import { ShareIcon, TwitterIcon } from 'svgs';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    marginRight: theme.spacing(4),
  },
  text2: {
    marginRight: theme.spacing(7.1),
  },
  button: {
    backgroundColor: '#FAFAFA !important',
    fontWeight: 400,
    border: '1px solid #EBEBEB !important',
    minHeight: 46,
    color: 'transparent !important',
    boxShadow: 'none',
    padding: `13px 19px !important`,
    marginRight: `${theme.spacing(2)}px !important`,
    marginBottom: `${theme.spacing(2)}px !important`,
    cursor: 'pointer',
    '&:hover': {
      color: 'transparent',
      backgroundColor: '#FAFAFA',
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: '0 !important',
      padding: `13px 24px !important`,
    },
    '& svg': {
      margin: 'auto',
    },
  },
  title: {
    fontWeight: 500,
    paddingLeft: theme.spacing(1),
    textTransform: 'capitalize',
  },
}));

const NewsSocialMediaSection: FC = () => {
  const classes = useStyles();
  const link = typeof location !== 'undefined' ? location.href : '';

  const [copySuccess, setCopySuccess] = useState('');
  const copyToClipboard = () => {
    setCopySuccess('Copied!');
    setTimeout(() => {
      setCopySuccess('');
    }, 2000);
  };

  return (
    <Grid container>
      <Grid xs={6} sm="auto" item>
        <FacebookShareButton url={link} className={classes.button}>
          <Box display="flex">
            <FacebookIcon />
            <Typography variant="body1" color="textSecondary" className={classes.title}>
              Facebook
            </Typography>
          </Box>
        </FacebookShareButton>
      </Grid>
      <Grid xs={6} sm="auto" item>
        <LinkedinShareButton url={link} className={classes.button}>
          <Box display="flex">
            <LinkedinIcon />
            <Typography variant="body1" color="textSecondary" className={classes.title}>
              LinkedIn
            </Typography>
          </Box>
        </LinkedinShareButton>
      </Grid>
      <Grid xs={6} sm="auto" item>
        <TwitterShareButton url={link} className={classes.button}>
          <Box display="flex">
            <TwitterIcon />
            <Typography variant="body1" color="textSecondary" className={classes.title}>
              Twitter
            </Typography>
          </Box>
        </TwitterShareButton>
      </Grid>
      <Grid xs={6} sm="auto" item>
        <Box display="flex">
          <CopyToClipboard text={link} className={classes.button}>
            <Box display="flex" onClick={copyToClipboard}>
              <ShareIcon />
              <Typography variant="body1" color="textSecondary" className={classes.title}>
                Share link
              </Typography>
            </Box>
          </CopyToClipboard>
          <Typography variant="subtitle2" color="textSecondary" style={{ margin: 'auto' }}>
            {copySuccess}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default NewsSocialMediaSection;
